module.exports = __webpack_public_path__ + "img/wenweipo.d97b0edd.jpg";